import persist from '@alpinejs/persist'
import alpine from 'alpinejs'

import addToCartForm from './components/add-to-cart-form'
import authentication from './components/authentication'
import brandFilter from './components/brand-filter'
import brands from './components/brands'
import checkout from './components/checkout'
import miniCart from './components/mini-cart'
import newsletterForm from './components/newsletter-form'
import primaryMenu from './components/primary-menu'
import product from './components/product'
import productCategory from './components/product-category'
import quantityInput from './components/quantity-input'
import radiatorCalculator from './components/radiator-calculator'
import readMore from './components/read-more'
import search from './components/search'
import sidebar from './components/sidebar'
import tooltip from './components/tooltip'

alpine.data('addToCartForm', addToCartForm)
alpine.data('authentication', authentication)
alpine.data('brandFilter', brandFilter)
alpine.data('brands', brands)
alpine.data('checkout', checkout)
alpine.data('miniCart', miniCart)
alpine.data('newsletterForm', newsletterForm)
alpine.data('primaryMenu', primaryMenu)
alpine.data('product', product)
alpine.data('productCategory', productCategory)
alpine.data('quantityInput', quantityInput)
alpine.data('radiatorCalculator', radiatorCalculator)
alpine.data('readMore', readMore)
alpine.data('search', search)
alpine.data('sidebar', sidebar)
alpine.data('tooltip', tooltip)

alpine.plugin(persist)

Object.assign(window, { Alpine: alpine }).Alpine.start()
